import React, { useContext } from "react";
import {
  FlexColumn,
  OurStack,
  ProjectNumbersH,
  StackItem,
  MainBlock,
  AdditionalInfoText,
  BlockContainer,
  NumbersTitle,
  OurStackInnerTitle,
  FlexWrap,
  MiniAdditional,
} from "./styles";
import { blockData, textData as data } from "../../content/data/HomeData";
import CTAButton from "../../common/CTAButton";
import { Spinning } from "./SpinningBlock";
import { Flex, GridContainer } from "../../common/Layouts/styles";
import { RefContext } from "../AppContext";
import { scrollTo } from "../../common/func";
import useIsMobile from "../../common/hooks/useIsMobile";

export const DesktopBlocks = () => {
  const { goodsBlockRef, contactBlockRef, blocksRef, setGoodsBlock } =
    useContext(RefContext);
  const { job } = blockData;
  const isMobile = useIsMobile();

  return (
    <BlockContainer
      ref={blocksRef}
      direction="column"
      gap={!isMobile ? "1vw" : "2vw"}
    >
      {isMobile ? <NumbersTitle>{data.ourStackTitle}</NumbersTitle> : null}
      <OurStack justify="space-between" align="center" gap="1vw">
        {!isMobile ? (
          <OurStackInnerTitle>{data.ourStackTitle}</OurStackInnerTitle>
        ) : null}
        <Flex gap="1vw">
          {blockData.stack.map((el, ind) => (
            <StackItem key={`stack-${ind}`}>{el}</StackItem>
          ))}
        </Flex>
      </OurStack>
      <GridContainer
        gap={isMobile ? "3vw" : "1.2vw"}
        cols={`${
          !isMobile
            ? "minmax(150px, 4fr) minmax(100px, 3fr) minmax(100px, 3fr)"
            : "minmax(200px, 1fr)"
        }`}
      >
        {isMobile ? <NumbersTitle>{data.numbers}</NumbersTitle> : null}
        {!isMobile ? <DesktopNumbersBlock /> : <MobileNumbersBlock />}
        <MainBlock gap="0">
          <NumbersTitle>{data.job}</NumbersTitle>
          <FlexWrap>{job}</FlexWrap>
        </MainBlock>
        <FlexColumn gap={isMobile ? "3vw" : "1vw"}>
          <CTAButton
            padding="0 2vw"
            fontSize={!isMobile ? "1.8vw" : "5vw"}
            onClick={() => {
              setGoodsBlock(true);
            setTimeout(() => scrollTo(goodsBlockRef), 100);
            }}
            arrowSize={!isMobile ? "2vw" : "4vw"}
            ellipsePadding={!isMobile ? "2vw" : "4vw"}
            flexGrow={1}
            borderRadius="100px"
          >
            {data.services.title1}
          </CTAButton>
          <CTAButton
            padding="0 2vw"
            fontSize={!isMobile ? "1.8vw" : "5vw"}
            onClick={() => scrollTo(contactBlockRef)}
            arrowSize={!isMobile ? "2vw" : "4vw"}
            ellipsePadding={!isMobile ? "2vw" : "4vw"}
            flexGrow={1}
            borderRadius="100px"
          >
            {data.services.title2}
          </CTAButton>
        </FlexColumn>
      </GridContainer>
      <Spinning />
    </BlockContainer>
  );
};

const DesktopNumbersBlock = () => {
  return (
    <MainBlock>
      <NumbersTitle>{data.numbers}</NumbersTitle>
      <Flex gap="5vw">
        <Flex direction="column">
          <ProjectNumbersH>{data.projects.details.years}</ProjectNumbersH>
          <AdditionalInfoText>{data.projects.InIT}</AdditionalInfoText>
        </Flex>
        <Flex direction="column">
          <Flex align="flex-end" gap="1vw">
            <ProjectNumbersH>
              {data.projects.details.projectTime}
            </ProjectNumbersH>
            <MiniAdditional>{data.projects.details.timeNumber}</MiniAdditional>
          </Flex>
          <AdditionalInfoText>{data.projects.users}</AdditionalInfoText>
        </Flex>
      </Flex>
    </MainBlock>
  );
};

const MobileNumbersBlock = () => {
  const isMobile = useIsMobile();

  return (
    <>
      {!isMobile ? <NumbersTitle>{data.numbers}</NumbersTitle> : null}
      <GridContainer gap="3vw" cols="minmax(100px, 1fr) minmax(100px, 1fr)">
        <MainBlock gap="1vw" direction="column">
          <ProjectNumbersH>{data.projects.details.years}</ProjectNumbersH>
          <AdditionalInfoText>{data.projects.InIT}</AdditionalInfoText>
        </MainBlock>
        <MainBlock gap="1vw" direction="column">
          <Flex align="flex-end">
            <ProjectNumbersH>
              {data.projects.details.projectTime}
            </ProjectNumbersH>
            <MiniAdditional>{data.projects.details.timeNumber}</MiniAdditional>
          </Flex>
          <AdditionalInfoText>{data.projects.users}</AdditionalInfoText>
        </MainBlock>
      </GridContainer>
    </>
  );
};
